import { useMutation } from "@tanstack/react-query";

import { api, useDoctorContext } from "@contexts";
import type { Request, RequestType } from "@interfaces";
import { RequestStatus } from "@interfaces";
import { useSetRequestDocumentType } from "./useSetRequestDocumentType";

export interface CreateRequestPayload {
  patientUuid: string;
  doctorCode: string;
  request: {
    documentType?: RequestType;
    status: RequestStatus;
    comment: string;
    indications: string;
  };
}

interface CreateRequestResponse {
  request: Request;
}

export const createRequestFn = (requestPayload: CreateRequestPayload) => {
  return api<CreateRequestResponse>({
    method: "POST",
    url: "/requests",
    data: requestPayload,
  });
};

interface CreateRequestParams {
  patientUuid: string;
  documentType: RequestType;
}

export const useCreateRequest = () => {
  const doctor = useDoctorContext();
  const { mutateAsync: setDocumentType } = useSetRequestDocumentType();

  return useMutation({
    mutationFn: async (params: CreateRequestParams) => {
      // Crear la request
      const requestResponse = await createRequestFn({
        patientUuid: params.patientUuid,
        doctorCode: doctor.code,
        request: {
          status: RequestStatus.DRAFT,
          comment: "",
          indications: "",
        },
      });

      await setDocumentType({
        requestId: requestResponse.request.id,
        documentType: params.documentType,
      });

      return {
        ...requestResponse.request,
        documentType: params.documentType,
      };
    },
  });
};
